export default {"src":"/login-app/[GIT_HASH]/_next/static/media/view_column.ee1e8af0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};